module.exports = __webpack_public_path__ + "static/img/作品92.5dd7465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品92.png
// module id = eTew
// module chunks = 1